import type { FaireProductEntity } from "../../entity_types/product";

export const p_8j3e6sz8s3: FaireProductEntity = {
  token: "p_8j3e6sz8s3",
  type: "product",
  name: "Skeleton Fun greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/2954b6611a5cb8ea6db30970f5228a41baf32d0fff69df8c7671a38acb060050.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description:
    "\n * Illustrated by Krista Perry \n * A2 - 4.25 x 5.5 inch \n * Soft White Cover Paper \n * Paper is 30% Recycled, FSC, and SFI Certified \n * Printed in Full Color + Neon with Soy-Based Inks\n\n * Blank Interior \n * Matching Envelope \n * Sold as Single Card \n * Printed in the USA ",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:32.838Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
